<template>
    <CustomTopSheetDialog v-model="show" :width="600" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('global.times-modal.open-times') }}
            </h3>
        </template>

        <template #default>
            <p>
                {{ $t('global.times-modal.text-time') }}
            </p>
            <template v-if="Array.isArray(shop?.businessHours)">
                <v-row v-for="entry in shop?.businessHours" :key="entry.id" justify="start" justify-md="center" class=""
                    dense="true">
                    <v-col class="px-2" cols="2" md="2">
                        {{ $getShortDay(entry.fromDay) }}
                    </v-col>
                    <v-col class="px-2" cols="2" md="2">
                        {{ $getShortDay(entry.toDay) }}
                    </v-col>
                    <v-col class="px-2 d-inline-flex" cols="3" md="3">
                        {{ entry.from.slice(0,5) }}
                        <!-- {{ entry.from.hour }}:{{ entry.from.minute == 0 ? '00' : entry.from.minute }} -->
                    </v-col>
                    <v-col class="px-2 d-inline-flex" cols="3" md="3">
                        {{ entry.to.slice(0,5) }}
                        <!-- {{ entry.to.hour }}:{{entry.to.minute == 0 ? '00' : entry.to.minute }} -->
                    </v-col>
                    <v-col class="px-2" cols="2" md="2">
                        <v-btn size="x-small" fab variant="flat" icon="mdi-delete-outline" color="error"
                            @click="() => removeBusinessHour(entry.id)"></v-btn>
                    </v-col>
                </v-row>
            </template>
            <v-divider></v-divider>
            <v-row justify="start" justify-md="center" class="" dense="true">
                <v-col class="px-2" cols="5" md="2" order="0" order-md="0">
                    <v-select v-model="dayFrom" placeholder="Mo" variant="outlined" density="compact"
                        :hide-details="true" :items="weekDays">
                        <template v-slot:selection="{ item }">
                            {{ $getShortDay(item.value) }}
                        </template>
                        <template v-slot:item="{ item, props }">
                            <v-list-item v-bind="props">
                                <template #title>
                                    <span>{{ $getShortDay(item.value) }}</span>
                                </template>
                            </v-list-item>
                        </template>
                    </v-select>
                </v-col>
                <v-col class="px-2" cols="5" md="2" order="1" order-md="1">
                    <v-select v-model="dayTo" placeholder="Fr" variant="outlined" density="compact" :hide-details="true"
                        :items="weekDays">
                        <template v-slot:selection="{ item }">
                            {{ $getShortDay(item.value) }}
                        </template>
                        <template v-slot:item="{ item, props }">
                            <v-list-item v-bind="props">
                                <template #title>
                                    <span>{{ $getShortDay(item.value) }}</span>
                                </template>
                            </v-list-item>
                        </template>
                    </v-select>
                </v-col>
                <v-col class="px-2 d-inline-flex" cols="5" md="3" order="3" order-md="2">
                    <v-text-field v-model="openHours" class="mr-1" variant="outlined" density="compact"
                        :hide-details="true" :rules="[onlyNumbers]"></v-text-field>
                    <v-text-field v-model.number="openMinutes" variant="outlined" density="compact"
                        :hide-details="true"></v-text-field>
                </v-col>
                <v-col class="px-2 d-inline-flex" cols="5" md="3" order="4" order-md="3">
                    <v-text-field v-model="closeHours" type="number" class="mr-1" variant="outlined" density="compact"
                        :hide-details="true"></v-text-field>
                    <v-text-field v-model="closeMinutes" type="number" variant="outlined" density="compact"
                        :hide-details="true"></v-text-field>
                </v-col>
                <v-col class="px-2" cols="2" md="2" order="2" order-md="4"> <v-btn fab variant="flat" icon="mdi-plus"
                        color="primary" @click="addBusinessHour()"></v-btn></v-col>
                <v-col cols="12" v-if="showError" order="8" order-md="8"> <v-label theme="error" color="error"> {{ errorText }} </v-label></v-col>
            </v-row>
        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="closeSheet">{{ $t('entity.action.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "EditShopHoursDialog",


    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        show: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    methods: {
        closeSheet() {
            this.show = false;
        },
    },
};
</script>
<script setup>
import { getCurrentInstance, inject, onMounted, ref, watch } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';

const weekDays = ['MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY']

const originalShop = inject('shop');


watch(() => originalShop.value, (newVal) => {
    shop.value = { ...newVal };
}, { deep: true });

const shop = ref({ ...originalShop.value });
const selectedLanguage = localStorage.getItem('selectedLanguage');
console.log('originalShop', originalShop)
const { proxy } = getCurrentInstance();
const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const softToken = localStorage.getItem("softToken");
// const openMinutesRaw = ref("00");

const onlyNumbers = (value) => {
    return /^[0-9]*$/.test(value) || "Only numbers are allowed";
};

const fetchOwnShop = inject('fetchOwnShop');
const openHours = ref('8')
const openMinutes = ref('00')
const closeHours = ref('20')
const closeMinutes = ref('00')
const dayFrom = ref('MONDAY')
const dayTo = ref('FRIDAY')
const showError = ref(false)
const errorText = ref('')

const addBusinessHour = async () => {

    const putObj = {
        from: `${String(openHours.value).padStart(2, '0')}:${String(openMinutes.value).padStart(2, '0')}`,
        fromDay: `${dayFrom.value}`,
        to: `${String(closeHours.value).padStart(2, '0')}:${String(closeMinutes.value).padStart(2, '0')}`,
        toDay: `${dayTo.value}`
    }
    console.log(putObj);
    try {
        const response = await proxy.$axios.put(`/shop/businesshour`, putObj, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });
        console.log(response.data.status == 200)
        console.log(response.data.status)
        if (response.data.status == 'OK') {
            shop.value = { ...response.data.data };
        } else if (response.data.status == 'ERROR') {
            if (response.data.fields != {}) {
                const fieldNames = Object.keys(response.data.fields);
                console.log(fieldNames[0]);
                if (fieldNames[0]) {
                    showError.value = true;
                    errorText.value = proxy.$t(`businesshour.${fieldNames[0]}.${response.data.fields[fieldNames[0]]}`)
                    console.log(`businesshour.${fieldNames[0]}.${response.data.fields[fieldNames[0]]}`)
                    console.error(proxy.$t(`businesshour.${fieldNames[0]}.${response.data.fields[fieldNames[0]]}`))
                }
            }
        }
    } catch (error) {
        console.error("Error deleting Obj:", error);
    }
    finally {
        // Shop update visible after refresh with code underneath instant
        // fetchOwnShop();
    }
}

const removeBusinessHour = async (id) => {
    if (!id) return;
    try {
        const response = await proxy.$axios.delete(`/shop/businesshour`, {
            params: {
                id: id
            },
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        if (response.data.status == "OK") {
            shop.value = { ...response.data.data };
        }
    } catch (error) {
        console.error("Error deleting Obj:", error);
    }
    finally {
        // Shop update visible after refresh with code underneath instant
        // fetchOwnShop();
    }
}



// const openMinutes = ref('00');
// const openMinutes = computed({
//     get: () => openMinutesRaw.value.padStart(2, "0"),
//     set: (value) => {
//         let num = parseInt(value, 10);
//         openMinutesRaw.value = isNaN(num) ? "00" : num.toString().padStart(2, "0");
//     }
// });
onMounted(() => {
    console.log('MOUNTED')
});

</script>
<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-field__input {
    padding-inline-end: 0px !important;
}
</style>
<style scoped></style>
